import { z } from 'zod';
import type { SeasonToken } from '@sleed/bizcommerce-api';

/**
 * Season edit form. Mirrors `SeasonToken` and the legacy admin grid
 * (Core/client/admin/src/pages/Catalog/Seasons/index.js): cd optional ≤50, nm required ≤100,
 * sdt/edt optional datetime windows, iv boolean, si required. The default-language name is saved
 * at the top level via the Accept-Language=el pin (parity with RelationTypes/PriceTypes).
 */
export const seasonSchema = z.object({
	id: z.number().optional(),
	cd: z.string().trim().max(50, 'validation.tooLong').nullable(),
	nm: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	sdt: z.string().nullable(),
	edt: z.string().nullable(),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int()
});

export type SeasonFormValues = z.infer<typeof seasonSchema>;

export const EMPTY_SEASON: SeasonFormValues = {
	cd: '',
	nm: '',
	sdt: null,
	edt: null,
	iv: true,
	si: 0
};

export function tokenToForm(token: SeasonToken): SeasonFormValues {
	return {
		id: token.id,
		cd: token.cd ?? '',
		nm: token.nm ?? '',
		sdt: (token.sdt as string | null) ?? null,
		edt: (token.edt as string | null) ?? null,
		iv: token.iv ?? false,
		si: token.si ?? 0
	};
}

export function formToToken(form: SeasonFormValues): SeasonToken {
	return {
		id: form.id,
		cd: form.cd?.trim() || null,
		nm: form.nm.trim(),
		sdt: form.sdt,
		edt: form.edt,
		iv: form.iv,
		si: form.si
	};
}
